<style lang="scss">
    @import '~@/assets/css/var';
    .table-title {
        margin-bottom: $intervalWidth;

        &__left {
            float: left;
            font-size: 15px;
            line-height: 28px;
        }

        &__right {
            float: right;
        }
        &__normal {
            display: inline-block;
            padding-right: $intervalWidth;
            &-type {
                width: 100px;
                .el-input__inner {
                    border-right: 0;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                    border-color: #DCDFE6 !important;
                }
            }
            &-value {
                width: 240px !important;
                input, &.el-input__inner {
                    border-left: 0;
                    border-radius: 0;
                    border-color: #DCDFE6 !important;
                }
                &.el-range-editor.el-input__inner {
                    padding: 2px 10px;
                }
            }
        }
    }
    .draggable {
        width: 300px;
        margin: 10px auto;
        &-item {
            position: relative;
            border: 1px solid $border;
            margin-bottom: -1px;
            padding: 10px;
            line-height: 20px;
            cursor: move;
            .el-switch {
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
            }

            &:first-child {
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
            }
            &:last-child {
                border-bottom-right-radius: 4px;
                border-bottom-left-radius: 4px;
            }
        }
        .sortable-ghost {
            opacity: .5;
        }
    }
    .advance {
        .el-button--text {
            font-size: 16px;
        }
        .el-form-item {
            margin: 0;
        }
        &-field {
            width: 150px;
            margin: 0 10px;
        }
        &-operate {
            width: 150px;
            margin-right: 10px;
        }
        &-value {
            .el-form-item__content > * {
                width: 220px;
            }
        }
    }
    .dropdown-size {
        .el-dropdown-menu__item {
            &.active {
                color: $main;
                i {
                    opacity: 1;
                }
            }
            &.show {
                i {
                    opacity: 1;
                }
            }
            i {
                opacity: 0;
            }
        }
    }
    .my-table-block {
        flex: 2;

        .expand {
            padding-left: 42px;
            padding-right: 50px;
        }

        .el-table__header {
            th {
                background: #f5f7fa;
            }
        }

        .el-table__body-wrapper {
            min-height: 150px;
            .el-link {
                font-size: 12px;
            }
        }
        .caret-wrapper {
            height: 21px;
            .ascending {
                top: 0 !important;
            }
            .descending {
                bottom: 0 !important;
            }
        }


        .el-pagination {
            padding: 10px 0 0;
            text-align: right;
            .el-select .el-input {
                margin: 0;
            }
            .el-dropdown {
                i {
                    font-size: 28px;
                }
            }
        }
    }

    .table-block-article {
        margin-top: 10px;
        .table-title {
            margin-bottom: 25px;
        }
        .scroll-title {
            font-size: 16px;
            margin: 7px 0 10px 20px;
            padding-left: 10px;
            font-weight: bold;
            border-left: 10px solid $main;
            display: inline-block;
        }
        .scroll-content {
            display: flex;
            flex-direction: column;
            border-right: 1px solid $border;
        }
        .el-pagination {
            text-align: left;
        }
        .front-table__panel {
            padding: 10px 20px;
            overflow-y: auto;
            box-sizing: border-box;
        }
        .front-table__item {
            display: flex;
            padding: 0 10px 0 0;
            margin-bottom: 15px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
        }
        .front-table__right {
            display: flex;
            flex: 1;
            flex-direction: column;
            justify-content: center;
            padding-left: 20px;

            p {
                color: #999;
                line-height: 22px;
            }
            .title {
                font-size: 17px;
                font-weight: bold;
                padding-bottom: 5px;
                color: #555;
                cursor: pointer;
                &:hover {
                    color: $main;
                }
            }
            .assist {
                font-size: 14px;
                line-height: 28px;
                height: 56px;
                color: #888;
                margin-bottom: 15px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .el-icon-user-solid {
                padding: 3px;
                border-radius: 50%;
                background: #999;
                color: #fff;
            }
            i {
                margin-right: 6px;
            }
            span {
                min-width: 55px;
            }
            .user {
                width: 110px;
            }
        }

        .tab-con {
            margin-left: 20px;
            padding-top: 10px;
            .el-tabs__item {
                width: 140px;
                text-align: center;
                color: #333;
                font-weight: bold;

                &.is-active {
                    background: $main;
                    color: #fff !important;
                }
            }
        }
    }
</style>

<template>

    <div class="my-table-block table-block-article flex flex-column flex-item" v-if="loaded" v-loading="loading">
        <div class="table-title" v-show="!hideOperate">
            <div class="scroll-title">{{pageName}}</div>
            <div class="table-title__right">
                <!--普通筛选-->
                <span class="table-title__normal">
                    <el-select class="table-title__normal-type" filterable v-model="normalSearchField" value-key="key" @change="normalSearchChange">
                        <el-option v-for="item in normalSearchList" :key="item.key" :label="item.value" :value="item"></el-option>
                    </el-select>

                    <template v-if="normalSearchField.type === $variable.colType.SELECT">
                        <my-select class="table-title__normal-value" v-model="normalSearchValue" :placeholder="`请选择${normalSearchField.value}`"
                                   :param="normalSearchField" @change="normalSearchSave"></my-select>
                    </template>
                    <template v-else-if="normalSearchField.type === $variable.colType.DATE">
                        <el-date-picker class="table-title__normal-value" v-model="normalSearchValue" type="daterange"
                                        unlink-panels value-format="yyyy-MM-dd"
                                        start-placeholder="开始日期" end-placeholder="结束日期" @change="normalSearchSave"></el-date-picker>
                    </template>
                    <template v-else>
                        <el-input class="table-title__normal-value" v-model="normalSearchValue" :placeholder="`请输入${normalSearchField.value}`">
                            <el-button slot="append" icon="el-icon-search" @click="normalSearchSave"></el-button>
                        </el-input>
                    </template>
                </span>

                <el-button-group v-if="!single">
                    <el-button class="btn-blue" plain icon="el-icon-search" @click="advanceSearchShow" v-if="!single">筛选</el-button>
<!--                    <el-button type="primary" plain icon="el-icon-setting" @click="columnSetShow" v-if="!single" >设置</el-button>-->
                    <el-button class="btn-blue" plain icon="el-icon-refresh" @click="refreshPage()" >刷新</el-button>
                    <slot name="right"></slot>
                </el-button-group>
            </div>
        </div>

        <div class="flex flex-item">
            <div class="scroll-panel flex flex-column flex-item">
                <div class="scroll-content flex-item">
                    <div ref="scroll-panel" class="front-table__panel flex-item">
                        <div class="front-table__item" v-for="item in data" :key="item.id">
                            <el-image style="width: 280px; height: 160px" fit="contain" :src="prefixUrl + item.picUrl"></el-image>
                            <div class="front-table__right">
                                <p class="title" @click.stop="updateOrReadRow(item)">{{item.title}}</p>
                                <p class="assist">{{item.contentDes}}</p>
                                <p class="flex">
                                    <span class="user">
                                        <i class="el-icon-user-solid"></i>{{item.makeName}}
                                    </span>
                                    <span class="flex-item">
                                        <i class="el-icon-time"></i>{{item.makeTime}}
                                    </span>
                                    <span @click.stop="triggerCommDraw(item)">
                                        <i class="el-icon-chat-dot-square"></i>{{item.comCount}}
                                    </span>
                                    <span @click.stop="triggerReadDraw(item)">
                                        <i class="el-icon-view"></i>{{item.readCount}}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <el-pagination v-if="!hidePage" :current-page.sync="pageParam.current" :page-sizes="[10, 20, 50]"
                               :page-size="pageParam.size" :layout="layout" :total="pageParam.total"
                               @size-change="handleSizeChange" @current-change="handleCurrentChange">
                </el-pagination>
            </div>

            <div class="tab-con">
                <CommComTabs ref="tabs" :api="api"  @updateOrReadRow="updateOrReadRow"></CommComTabs>
            </div>
        </div>

        <!--列设置-->
        <my-dialog :show.sync="columnSet.show" title="列设置" width="350px" hide-footer>
            <draggable class="draggable" v-model="list" @end="saveListCustom">
                <transition-group name="no">
                    <div class="draggable-item" v-for="element in list" :key="element.key">
                        {{element.value}}
                        <el-switch v-model="element.viewSelf" @change="saveListCustom"></el-switch>
                    </div>
                </transition-group>
            </draggable>
        </my-dialog>

        <!--高级筛选-->
        <my-dialog class="advance" :show.sync="advanceSearch.show" title="设置筛选" is-cancel-event cancel-txt="重置"
                   sure-txt="筛选" cancel-icon="el-icon-refresh" width="610px" @save="advanceSearchSave" @cancel="advanceSearchCancel">
            <el-form inline v-for="(item, index) in advanceSearch.list" :key="index">

                <el-button class="btn-text-red" type="text" @click="advanceSearch.list.splice(index, 1)"><i class="el-icon-remove"></i></el-button>

                <el-form-item>
                    <el-select class="advance-field" v-model="item.field" placeholder="请选择字段" value-key="key">
                        <el-option v-for="field in advanceSearchList" :key="field.key" :label="field.value" :value="field"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-select class="advance-operate" v-model="item.operate" placeholder="请选择操作" value-key="id">
                        <el-option v-for="field in advanceSearch.operateList" :key="field.key" :label="field.value" :value="field.key"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item v-if="item.field" class="advance-value">
                    <template v-if="item.field.type === $variable.colType.SELECT">
                        <my-select v-model="item.model" :placeholder="`请选择${item.field.value}`" :param="item.field"></my-select>

                    </template>
                    <template v-else-if="item.field.type === $variable.colType.DATE">
                        <el-date-picker v-model="item.model" type="daterange" unlink-panels style="width: 220px" value-format=""
                                        start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </template>
                    <template v-else>
                        <el-input v-model="item.model" :placeholder="`请输入${item.field.value}`"></el-input>
                    </template>
                </el-form-item>
            </el-form>
            <el-button type="text" @click="advanceSearch.list.push({})"><i class="el-icon-circle-plus"></i></el-button>
        </my-dialog>


        <el-drawer  :visible.sync="commentDialog.show"  append-to-body destroy-on-close class="my-drawer-title"
                   title="评论"
                   direction="rtl"
                   size="50%" @changeFullScreen="changeComFullScreen">
            <comm-comment  :com-cols="comCols" :com-api="comApi" :head-id="headId">

            </comm-comment>
        </el-drawer>

        <el-drawer append-to-body destroy-on-close  class="my-drawer-title"
                title="观看信息"
                direction="rtl"
                :visible.sync="readDialog.show"
                size="50%"  @changeFullScreen="changeReadFullScreen">

            <comm-read :read-cols="readCols" :read-api="readApi" :head-id="headId">
            </comm-read>

        </el-drawer>


    </div>

</template>

<script>
    import help from '@/util/help';
    import variable from '@/util/variable';
    import draggable from 'vuedraggable';
    import CommComment from "@/components/CommComment";
    import CommRead from "@/components/CommRead";
    import CommComTabs from "@/components/CommComTabs";

    export default {
        components: {CommComTabs, CommRead, CommComment, draggable},
        props: {
            // 表格里的操作列
            operate: {
                type: Array,
                default: () => {
                    return []
                }
            },
            isShowDel:{

            },
            api: {

            },
            comApi:{

            },
            comCols: {
                type: Array,
                default: () => {
                    return []
                }
            },
            readApi: {

            },
            readCols: {
                type: Array,
                default: () => {
                    return []
                }
            },
           // 列表是否在加载中
            loading: {
                type: Boolean,
                default: false
            },
            // 列的表头
            cols: {
                type: Array,
                default: () => {
                    return []
                }
            },
            stripe: {
                type: String,
            },
            operateWidth: {},
            // 表数据
            data: {
                type: Array,
                default: () => {
                    return []
                }
            },
            // 批量操作列表
            batch: {
                type: Array,
                default: () => {
                    return []
                }
            },
            // 页面名称
            pageName:{
                type: String,
            },
            // 表格唯一表示
            name: {},
            // 隐藏操作行
            hideOperate: {
                type: Boolean,
                default: false
            },
            // 表高度
            height: {
                type: Number,
                default: 250,
            },
            // 是否显示el-table的单选
            isShowSingleChecked: {
                type: Boolean,
                default: false
            },
            // 是否隐藏序列
            hideSerial: {
                type: Boolean,
                default: false
            },
            // 是否隐藏分页
            hidePage: {
                type: Boolean,
                default: false
            },
            // 是否隐藏多选列
            hideMultiple: {
                type: Boolean,
                default: false
            },
            // 是否简单类型
            single: {
                type: Boolean,
                default: false
            },
            canUpdate: {
                type: Boolean
            },
            // 页码的相关参数
            pageParam: {
                type: Object,
                default: () => {
                    return {
                        index: 1,
                        size: 20,
                        total: 0
                    }
                }
            },
            layout: {
                default: 'prev, pager, next, total, sizes'
            },
        },
        data() {
            return {
                variable,
                loaded: false,
                maxCom: false,
                maxRead: false,
                list: [],
                drawerCom: false,
                drawerRead: false,
                comList: [],
                readList: [],
                prefixUrl: variable.cdn,

                // 表格尺寸
                size: help.store.get('tableSize') || variable.tableSize[0].key,
                hasLine: !!help.store.get('tableLine'),

                // 普通筛选
                normalSearchField: {},
                normalSearchValue: '',

                // 列设置
                columnSet: {
                    show: false,
                },

                // 高级查询
                advanceSearch: {
                    show: false,
                    list: [],
                    operateList: [
                        {key: 'eq', value: '等于'},
                        {key: 'ne', value: '不等于'},
                        {key: 'gt', value: '大于'},
                        {key: 'ge', value: '大于等于'},
                        {key: 'lt', value: '小于'},
                        {key: 'le', value: '小于等于'},
                        {key: 'like', value: '包含'},
                        {key: 'in', value: '属于'},
                        {key: 'notIn', value: '不属于'},
                    ],
                },

                commentDialog: {
                    show: false,
                },
                headId:'',
                readDialog: {
                    show: false,
                },

            }
        },
        created() {
            this.getList();
            // 赋值普通筛选
            for (let i = 0; i < this.cols.length; i += 1) {
                if (this.cols[i].searchNormal) {
                    this.normalSearchField = this.cols[i];
                    this.normalSearchChange();
                    return
                }
            }
        },
        computed: {
            // 普通筛选的列表
            normalSearchList() {
                if (this.cols && this.cols.length > 0) {
                    return (
                        this.cols.filter(item => item.searchNormal)
                    )
                }
                return []
            },
            // 高级筛选的列表
            advanceSearchList() {
                if (this.cols && this.cols.length > 0) {
                    return (
                        this.cols.filter(item => item.searchAdvance)
                    )
                }
                return []
            },
        },
        mounted() {
            this.loaded = true
            this.$nextTick(() => {
                const el = this.$refs['scroll-panel']
                el.style.height = el.clientHeight + 'px'
                el.style.flex = 'unset'
            })
        },
        methods: {
            getList() {
                if (this.cols && this.cols.length > 0) {
                    let list = help.deepClone(this.cols);

                    // 从localstorage里获取相关配置
                    const custom = help.store.get(`config_${this.name}`) || {};
                    list.map(item => {
                        if (custom[item.key]) {
                            item.viewSelf = !!custom[item.key].viewSelf;
                        } else {
                            item.viewSelf = true
                        }
                        return item;
                    })

                    list = list.sort((a, b) => {
                        return a.viewSort - b.viewSort;
                    });

                    this.list = list;
                } else {
                    this.list = []
                }
            },
            saveListCustom() {
                const param = {};
                this.list.forEach((item, index) => {
                    const obj = {};
                    obj.viewSort = index + 1;
                    obj.viewSelf = item.viewSelf ? 1 : 0;
                    param[item.key] = obj
                })
                help.store.set(`config_${this.name}`, JSON.stringify(param));
            },
            // 表格尺寸修改
            tableSizeChange(command) {
                if (command) {
                    this.size = command;
                    help.store.set('tableSize', this.size);
                }
            },
            tableLineChange() {
                help.store.set('tableLine', this.hasLine ? 1 : 0);
            },

            getCheckedRows() {
                return this.$refs.table.selection;
            },
            triggerCommDraw(row) {
                this.headId = row.id;
                this.commentDialog.show = true;
            },
            triggerReadDraw(row) {
                this.headId = row.id;
                this.readDialog.show = true;
            },
            updateOrReadRow(row) {
                // 有修改权限就修改 没有就查看
                this.$emit('readOrUpdateEvent', row);
            },
            // 批量操作
            batchCommand(command) {
                const list = this.getCheckedRows();
                if (list.length > 0) {
                    if (command.api) {
                        this.$store.commit('confirm', {
                            title: '提示',
                            content: `确定${command.txt}`,
                            callback: (next, back) => {
                                const key = command.key || 'id'
                                this.$api.post(command.api, list.map(item => {
                                    const param = {}
                                    param[key] = item[key]
                                    return param
                                }))
                                    .then(res => {
                                        this.$help.success(res.errorTotalMsg)
                                        this.$emit('refresh')
                                        next()
                                    })
                                    .finally(back)
                            }
                        })
                    } else {
                        command && command.event(list)
                    }
                } else {
                    this.$help.error('请至少选择一行数据')
                }
            },

            // 普通筛选
            normalSearchChange() {
                this.normalSearchValue = '';
                // if (this.normalSearchField.type === 'das') {
                //     console.log('预留代码');
                // } else {
                //
                // }
            },
            normalSearchSave() {
                setTimeout(() => {
                    const param = {};
                    switch (this.normalSearchField.type) {
                        case variable.colType.DATE:
                            param[`${this.normalSearchField.key}Start`] = this.normalSearchValue[0]
                            param[`${this.normalSearchField.key}End`] = this.normalSearchValue[1]
                            break
                        case variable.colType.SELECT:
                            param[this.normalSearchField.key] = `${this.normalSearchValue}`
                            break
                        default:
                            param[`${this.normalSearchField.key}Like`] = this.normalSearchValue
                    }

                    this.$emit('paramChange', param);
                }, 0)
            },

            // 列设置
            columnSetShow() {
                this.columnSet.show = true;
            },

            // 高级筛选
            advanceSearchShow() {
                if(this.advanceSearch.list.length === 0) {
                    this.advanceSearch.list.push({});
                }
                this.advanceSearch.show = true;
            },
            advanceSearchCancel() {
                this.advanceSearch.list = [{}]
            },
            advanceSearchSave() {
                const param = [];
                this.advanceSearch.list.forEach(item => {
                    if (item.field && item.model && item.operate) {
                        param.push({
                            advancedFieldName: item.field.key,
                            advancedFieldValue: item.model,
                            advancedFieldOperator: item.operate
                        })
                    }
                })

                this.$emit('cndClusterChange', param)
                this.advanceSearch.show = false;
            },


            handleRowDbClickChange(row) {
                this.$emit('handleRowDbClickChange', row)
            },

            handleRowClickChange(row) {
                this.$refs.table.toggleRowSelection(row)
                this.$emit('handleRowClickChange', row)
            },
            sort(row) {
                this.$emit('sort', row)
            },

            // region 分页等操作
            handleSizeChange(val) {
                this.$emit('pageChange', {
                    size: val,
                    current: 1
                })
            },
            handleCurrentChange(val) {
                this.$emit('pageChange', {
                    current: val
                })
            },
            handleSelect(selection, row) {
                this.$emit('handleSelect', selection, row)
            },
            // endregion
            changeComFullScreen() {
                this.maxCom = !this.maxCom;
            },
            changeReadFullScreen() {
                this.maxRead = !this.maxRead;
            },
            refreshPage() {
                this.$emit('init')
                this.$refs.tabs.loadData()
            }

        }
    }
</script>
